import Footnote from './Footnote';
import FootnoteLink from './FootnoteLink';
Footnote.Link = FootnoteLink;
export default Footnote;